<template>
  <div class="Empty">
    <img
      :src="require('./../../../../assets/images/product-empty.png')"
      alt
    />
    <p>{{TLang('抱歉没有找到相关的商品哦','list')}}</p>
    <div class="empty-bottom_btn">
      <span
        @click="searchAll"
      >{{TLang('返回上一步','list')}}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'Empty',
  props:{
    topre: Function,
  },
  computed: {
    ...mapGetters('shopCart', ['exts', 'healthgoodsFlag']),
  },
  methods: {
    searchAll(){
      this.topre();
      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.Empty {
  width: 100%;
  margin-top: 20px;
  text-align: center;
  img {
    width: 500px;
  }
  p {
    font-size: 15px;
    color: #999;
  }
  .empty-bottom_btn {
    margin-top: 40px;
    margin-bottom: 50px;
    span {
      display: inline-block;
      width: 136px;
      height: 40px;
      background:linear-gradient(327deg,rgba(124,177,208,1) 0%,rgba(70,121,163,1) 100%);
      border-radius: 4px;
      line-height: 40px;
      color: #fff;
      font-weight: bold;
      cursor: pointer;
    }
  }
}
</style>
